import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used to indicate how many steps are needed to finish the user flow
 * in some process.
 */
var StepProgressBarComponent = /** @class */ (function (_super) {
    __extends(StepProgressBarComponent, _super);
    function StepProgressBarComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepProgressBarComponent.prototype.stepClass = function (step) {
        if (step < this.currentStep) {
            return 'step--done';
        }
        else if (step === this.currentStep) {
            return 'step--current';
        }
    };
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], StepProgressBarComponent.prototype, "steps", void 0);
    __decorate([
        Prop({ type: Number, default: 1 }),
        __metadata("design:type", Number)
    ], StepProgressBarComponent.prototype, "currentStep", void 0);
    StepProgressBarComponent = __decorate([
        Component({
            name: 'ui-step-progress-bar',
        })
    ], StepProgressBarComponent);
    return StepProgressBarComponent;
}(Mixins(MagicConfigMixin)));

export default StepProgressBarComponent;
